import React from "react";
import { PageHeader } from "@/components/common";
import { PatientTable } from "@/components/PatientTable";

export default function Assignments() {
  return (
    <div>
      <PageHeader title="Patient Assignments" subtitle="Tick patients and choose a Wellness Navigator to assign or reassign in bulk, or change a single patient in the Wellness Navigator column. Assignment history is preserved." />
      <PatientTable />
    </div>
  );
}
